import React from 'react';
import CalendarIcon from 'components/icon/calendar-icon';
import { buildClassName } from 'utils/build-class-name';
import { useOpenHouse } from 'ui/open-house';
import styles from './style.module.scss';
import { testIds } from 'constants/test-constants';
import type { OpenHouseDisplayData } from 'ui/open-house';

import type Listing from 'data/listing';

interface Props {
  openHouses: Listing['openHouses'];
}

export default function ListingOpenHouses({ openHouses }: Props) {
  const openHouseData = useOpenHouse(openHouses);

  return openHouseData.hasValue ?
    <div className={styles['open-house']}>
      <div data-testid={testIds.openhousesTitle}>
        <CalendarIcon />
        {openHouseData.label}
      </div>
      <div>
        {openHouseData.openHouses.map((openHouse, index) => (
          <OpenHouseLabel key={index} openHouse={openHouse} />
        ))}
      </div>
    </div> : null;
}

/**
 * Individual open house label component that uses the hook for formatting.
 */
function OpenHouseLabel({ openHouse }: { openHouse: OpenHouseDisplayData }) {
  return (
    <span className={buildClassName(!openHouse.isActive && styles.inactive)}>
      {openHouse.label}
    </span>
  );
}
